<template>
  <div
    class="box flex h-full flex-col overflow-hidden rounded-md shadow-xl sm:mx-5"
  >
    <PdfViewer :url="pdfUrl" :title="title" :download-title="title">
      <template #toolbar-left>
        <BaseButton
          :title="$t('button.back')"
          icon="long-arrow-left"
          inverse-icon-order
          color="warning"
          size="small"
          @click="$router.go(-1)"
        />
      </template>
      <template #option-pane="{ loaded, download, print }">
        <div class="flex flex-col gap-2">
          <BaseButton
            :title="$t('button.download')"
            icon="download"
            color="primary"
            :disabled="!loaded"
            @click="download"
          />
          <BaseButton
            :title="$t('button.print')"
            icon="print"
            color="primary"
            :disabled="!loaded"
            @click="print"
          />
        </div>
      </template>
    </PdfViewer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import PdfViewer from '@c/PdfViewer/PdfViewer.vue'

export default {
  name: 'InvoicingPrintPage',
  components: { PdfViewer },
  props: {
    invoicing_id: { type: String, required: true }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth',
      invoice: 'invoicing/getInvoice'
    }),
    pdfUrl() {
      return `api/render/invoicing/${this.invoicing_id}?lang=${this.auth.language}`
    },
    title() {
      if (this.invoice?.id?.toString() !== this.invoicing_id) return ''
      const type = this.$t(`global.invoicing_type.${this.invoice.doc_type}`)
      return [type, this.invoice.reference].filter(Boolean).join(' ')
    }
  },
  mounted() {
    if (this.invoice?.id?.toString() !== this.invoicing_id) {
      this.fetchInvoiceID({ id: this.invoicing_id })
    }
  },
  methods: {
    ...mapActions({ fetchInvoiceID: 'invoicing/fetchInvoiceID' })
  }
}
</script>
